import { forwardRef, type PropsWithChildren } from "react";

import { IconButton, type IconButtonProps } from "./icon-button";

export const DangerIconButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<Omit<IconButtonProps, "variant">>
>(({ children, ...props }, ref) => {
  return (
    <IconButton ref={ref} variant="danger" {...props}>
      {children}
    </IconButton>
  );
});
